import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent from 'agent'

import * as actions from 'redux/actions/users.actions'

function* getUsersSaga() {
  try {
    const body = yield call(agent.Users.getAll)
    const users = body.data

    yield put(actions.getUsersSuccess(users))
  } catch (error) {
    yield put(actions.getUsersFailure(error))
  }
}

function* deleteUserSaga(params) {
  try {
    const { id } = params.payload
    yield call(agent.Users.del, id)
    yield put(actions.deleteUserSuccess())

    // Refresh the users
    yield put(actions.getUsers())
  } catch (error) {
    yield put(actions.deleteUserFailure(error))
  }
}

function* addUserSaga(params) {
  try {
    const { payload } = params.payload
    yield call(agent.Users.create, payload)

    // Refresh the users
    yield put(actions.getUsers())

    yield put(actions.addUserSuccess())
  } catch (error) {
    let errors = {}
    if (error.response.status === 401) {
      errors = {
        password: ['Incorrect password']
      }
    } else {
      errors = error.response.body.errors
    }
    yield put(actions.addUserFailure(errors))
  }
}

function* editUserSaga(params) {
  try {
    const { id, payload } = params.payload
    yield call(agent.Users.update, id, payload)

    // Refresh the users
    yield put(actions.getUsers())

    yield put(actions.editUserSuccess())
  } catch (error) {
    let errors = {}
    if (error.response.status === 401) {
      errors = {
        password: ['Incorrect password']
      }
    } else {
      errors = error.response.body.errors
    }

    yield put(actions.editUserFailure(errors))
  }
}
function* domainAccessSaga(params) {
  try {
    const { id, payload } = params.payload
    yield call(agent.Users.domainAccess, id, payload)

    // Refresh the users
    yield put(actions.getUsers())

    yield put(actions.domainAccessSuccess())
  } catch (error) {
    let errors = {}
    if (error.response.status === 401) {
      errors = {
        password: ['Incorrect password']
      }
    } else {
      errors = error.response.body.errors
    }

    yield put(actions.domainAccessFailure(errors))
  }
}

export default function* usersSagas() {
  yield all([
    takeLatest(actions.getUsers.type, getUsersSaga),
    takeLatest(actions.deleteUser.type, deleteUserSaga),
    takeLatest(actions.addUser.type, addUserSaga),
    takeLatest(actions.editUser.type, editUserSaga),
    takeLatest(actions.domainAccess.type, domainAccessSaga)
  ])
}
